import React from "react";
import { Routes, Route } from "react-router-dom";
import MainRoutes from "../Routing/MainRoutes";
import Header from "../Conponents/Header/Header";
import "../../assets/style.css";
import Footer from "../Conponents/Header/Footer";
import { Grid } from "@mui/material";

const Index = () => {
  return (
    <div className="bg-light ">
      <Header />
      <Grid
        className="overflow-scroll"
        style={{ marginTop: "105px", marginBottom: "50px" }}
      >
        <Routes>
          {MainRoutes.map((route, i) => {
            return <Route path={route.path} element={route.element} key={i} />;
          })}
        </Routes>
      </Grid>
      {/* <Footer /> */}
    </div>
  );
};

export default Index;
